import React, { Component } from 'react';
import { Row, Col, Form, Input, Icon, Tooltip, Button, Divider, message } from 'antd';
import FooterControls from './FooterControls';
import { VIEWS } from '../../../utils/yourAccountUtils';
import { ssFormValidationUtils } from '@bit/ui-common.ui-components/ss-utils';
import validator from 'validator';
const { validationRules } = ssFormValidationUtils;

class DataEntry extends Component {
    constructor(props) { super(props); }

    formatInput(f, v) {
        switch(f) {
            case 'Role': return v === 'PROVIDER_ADMIN' ? 'Provider Admin' : v;
            default: return v;
        }
    }

    render() {
        const { field, children, format, value, style } = this.props;
        return (
            <Row type='flex' justify='space-around' align='middle' gutter={8} style={style}>
                <Col span={6}>
                    <span style={{ fontWeight: 'bold' }}>
                        {`${field}:`}
                    </span>
                </Col>
                <Col span={18} style={{ textAlign: 'left' }}>
                    {format ? this.formatInput(field, value) : children}
                </Col>
            </Row>
        );
    }
}

export default class AccountInfo extends Component {
    constructor(props) { super(props); }

    highlighter(entries) {
        let
        keyPrefix = 'your-account-edit-contact-info-',
        commonStyle = {
            lineHeight: '30px',
            borderRadius: '4px',
            overflow: 'auto'
        },
        props = (i) => ({
            key: `${keyPrefix}${i}`,
            style: commonStyle
        });
        return entries.map((e, i) => i%2 === 0
            ? React.cloneElement(e, {...props(i), style: {...commonStyle, background: 'rgb(240, 240, 240)' }})
            : React.cloneElement(e, {...props(i)})
        );
    }

    checkEmail(email) {
        if(email != null) {
            let validEmail = validationRules.isEmail(email);
            
            if(!validEmail.valid)
                return validEmail.help;
        } else return false;
    }

    checkPhone(phone) {
        if(phone != null) {
            let validPhone = validationRules.isPhone(phone);
            if(!validPhone.valid)
                return validPhone.help;
        } else return false;
    }

    checkGovEmail(email) {
        if(email != null) {
            let validGovEmail = validationRules.isGov(email);
            
            if(!validGovEmail.valid)
                return validGovEmail.help;
        } else return false;
    }

    handleSave() {
        const
        { jti } = window.session,
        { emailAddress, phoneNumber } = this.props,
        { updateContactInfo, changeView } = this.props.services;

        updateContactInfo(jti, { updatedContactInformation: [
            { contactValue: emailAddress, contactType: 'EMAIL' },
            { contactValue: phoneNumber, contactType: 'PHONE_NUMBER' },
        ]});

        changeView(VIEWS.YOUR_ACCOUNT);
    }

    render() {
        const
        p = this.props,
        { services } = p,
        { updateContactInfo } = p.requests,
        emailCheck = this.checkEmail(p.emailAddress),
        govEmailCheck = this.checkGovEmail(p.emailAddress),
        phoneCheck = this.checkPhone(p.phoneNumber);

        return (
            <div>
                <div style={{ position: 'absolute', top: '68px', right: '10px' }}>
                    <Tooltip placement='left' title='Save contact info.'>
                        <Button
                            size='small'
                            type='primary'
                            icon='check-circle-o'
                            onClick={() => this.handleSave()}
                            style={{ width: '74px', borderRadius: '20px' }}
                            disabled={phoneCheck === 'Must be a phone number' || emailCheck === 'Must be an email' || (p.role === 'DOD' && govEmailCheck === 'Must be a .gov or .mil email address') ? true : false}
                        >
                            {'Done'}
                        </Button>
                    </Tooltip>
                </div>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={12}>
                        {this.highlighter([
                            <DataEntry field='Name' format={true} value={
                                `${p.firstName != null && p.firstName.length > 0 ? p.firstName : ''}` +
                                `${p.lastName != null && p.lastName.length > 0 ? ` ${p.lastName}` : '-'}`
                            } />,
                            <DataEntry field='Role' format={true} value={p.role} />,
                            <DataEntry field='Phone'>
                                <Input
                                    style={{ width: '100%' }}
                                    size='small'
                                    name='phoneNumber'
                                    value={p.phoneNumber}
                                    onChange={e => services.updateDataEntry(e)}
                                />
                                {phoneCheck !== 'Must be a phone number' ? null : (
                                    <div style={{ color: 'red', marginTop: '-9px' }}>
                                        {this.checkPhone(p.phoneNumber)}
                                    </div>
                                )}
                            </DataEntry>,
                            <DataEntry field='Email'>
                                <Input
                                    style={{ width: '100%' }}
                                    size='small'
                                    name='emailAddress'
                                    value={p.emailAddress}
                                    onChange={e => services.updateDataEntry(e)}
                                />
                                {emailCheck !== 'Must be an email' ? null : (
                                    <div style={{ color: 'red'}}>
                                        {this.checkEmail(p.emailAddress)}
                                    </div>
                                )}
                                {govEmailCheck !== 'Must be a .gov or .mil email address' || p.role !== 'DOD' ? null : (
                                    <div style={{ color: 'red'}}>
                                        Must be a .gov or .mil email
                                    </div>
                                )}
                            </DataEntry>
                        ])}
                    </Col>
                </Row>
                <FooterControls {...p} disableButtons={true} />
            </div>
        );
    }
}
